'use client';
import { useTranslations } from '../utils/translations';

export default function MadameLenormandSection() {
  const { t } = useTranslations();
  
  return (
    <section className="w-full bg-[var(--bg-main)] py-4 sm:py-6 md:py-8 lg:py-[10px] mb-2 sm:mb-[10px]">
      <div className="w-full max-w-[1600px] mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Main Content Row */}
        <div className="flex flex-row justify-start items-center w-full">
          
          {/* Content Column with background */}
          <div
            className="flex flex-col justify-start items-center w-full h-auto bg-[var(--bg-overlay)] rounded-[12px] sm:rounded-[14px] md:rounded-[16px] py-3 sm:py-4 md:py-5 lg:py-[20px]">

            
            {/* Inner Content Column */}
            <div className="flex flex-col justify-start items-center w-full gap-4 sm:gap-6 md:gap-8 lg:gap-[40px] px-3 sm:px-4 md:px-6 lg:px-8">
              
              {/* Section Title */}
                <h2 className="text-center text-[var(--text-primary)] font-medieval text-[24px] sm:text-[32px] underline decoration-[#cfb284]/40 underline-offset-8 mt-6 mb-5" style={{ fontFamily: 'MedievalSharp' }}>
                  {t('home.madame_lenormand.heading')}
                </h2>

              
              {/* Historical Text */}
              <p className="text-center text-[var(--text-primary)] font-inter font-medium text-[14px] sm:text-[16px] leading-relaxed w-full max-w-6xl px-2 sm:px-4 break-words overflow-wrap-anywhere">
                {t('home.madame_lenormand.text')}
              </p>
              
              {/* Bottom Decorative Divider */}
              <div className="flex flex-row justify-center items-center w-full px-2 sm:px-4 md:px-8 lg:px-14 bg-transparent mb-[29px]">
                <svg 
                  id="Layer_2" 
                  xmlns="http://www.w3.org/2000/svg" 
                  version="1.1" 
                  viewBox="0 0 604.07 63.25"
                  className="w-[90%] sm:w-[90%] md:w-[90%] lg:w-[90%] h-auto max-w-[1200px] max-h-[70px]"
                >
                  <g className="fill-white dark:fill-black">
                    <path d="M577.54,27.45c-2,0-3.66,1.41-4.07,3.28h-197.9c-.41-1.87-2.07-3.28-4.07-3.28-2.3,0-4.17,1.87-4.17,4.17s1.87,4.17,4.17,4.17c1.99,0,3.66-1.41,4.07-3.28h197.9c.41,1.87,2.07,3.28,4.07,3.28,2.3,0,4.17-1.87,4.17-4.17s-1.87-4.17-4.17-4.17Z"/>
                    <path d="M248.9,27.45c-2,0-3.66,1.41-4.07,3.28H46.93c-.41-1.87-2.07-3.28-4.07-3.28-2.3,0-4.17,1.87-4.17,4.17s1.87,4.17,4.17,4.17c2,0,3.66-1.41,4.07-3.28h197.9c.41,1.87,2.07,3.28,4.07,3.28,2.3,0,4.17-1.87,4.17-4.17s-1.87-4.17-4.17-4.17Z"/>
                  </g>
                  <g className="fill-white dark:fill-black">
                    <path d="M324.68,36.72c-8.56.05-15.04,2.87-16.67,6.02-.57,1.14-1.96,5.64,1.91,5.67,4.15.02,2.98-4.57,2.27-5.9-1.56-2.86-9.63-5.6-16.57-5.81-6.64-.15-15.45,4.21-26.82,6.79-11.22,2.52-25,3.25-37.94-5.37,27.43,14.28,38.67-3.56,64.83-2.23,5.65.19,14.5,2.37,16.76,6.53,1.21,2.28,2.6,7.11-2.49,7.13-4.32,0-3.67-4.19-2.28-6.73,1.63-2.95,6.48-6.65,17-6.93,26.05-1.32,37.81,16.5,64.87,2.21-12.7,8.56-26.25,7.91-37.45,5.45-11.34-2.51-20.33-6.84-27.43-6.83Z"/>
                    <path d="M324.68,26.53c-8.56-.05-15.04-2.88-16.67-6.02-.57-1.14-1.96-5.64,1.91-5.67,4.15-.02,2.98,4.57,2.27,5.9-1.56,2.86-9.63,5.6-16.57,5.81-6.64.16-15.45-4.21-26.82-6.79-11.22-2.52-25-3.25-37.94,5.37,27.43-14.28,38.67,3.56,64.83,2.23,5.65-.19,14.5-2.37,16.76-6.52,1.21-2.28,2.6-7.11-2.49-7.13-4.32,0-3.67,4.18-2.28,6.73,1.63,2.95,6.48,6.65,17,6.93,26.05,1.32,37.81-16.5,64.87-2.21-12.7-8.56-26.25-7.91-37.45-5.45-11.34,2.51-20.33,6.84-27.43,6.83Z"/>
                  </g>
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>);

}